export default {
  apiKey: "AIzaSyCsjZgb4I-tnKeTH6itdprSVu4-pkH1yas",
  authDomain: "pro-akustik-dev.firebaseapp.com",
  databaseURL: "https://pro-akustik-dev.firebaseio.com",
  projectId: "pro-akustik-dev",
  storageBucket: "pro-akustik-dev.appspot.com",
  messagingSenderId: "1020049990726",
  appId: "1:1020049990726:web:f051830dfcb7f0d9d35647",
  measurementId: "G-LDKTC7TCBW"
}